import React from 'react';
import RefundContainer from 'containers/RefundContainer/RefundContainer';

export default function RefundPage() {
  return <RefundContainer />;
}
